import dayjs from "dayjs";
import { clampDayToMonth } from "./dashboardDay";

export const SUMMARY_PERIOD = { DAY: "today", MONTH: "month", YEAR: "year" };

const PERIOD_VALUES = Object.values(SUMMARY_PERIOD);

const normalizePeriod = (value) => (PERIOD_VALUES.includes(value) ? value : SUMMARY_PERIOD.DAY);

export const buildDrilldownSearch = ({ year, month, day, dateRange, warehouse, period }) =>
  new URLSearchParams({
    year: String(year),
    month: String(month),
    day: String(day),
    period: normalizePeriod(period),
    start_date: dateRange?.[0] ?? "",
    end_date: dateRange?.[1] ?? "",
    warehouse: String(warehouse ?? "all"),
  }).toString();

const toNumber = (value) => {
  const parsed = Number(value);
  return value != null && value !== "" && Number.isFinite(parsed) ? parsed : undefined;
};

export const readDrilldownParams = (searchParams) => ({
  year: toNumber(searchParams.get("year")) ?? dayjs().year(),
  month: toNumber(searchParams.get("month")),
  day: toNumber(searchParams.get("day")),
  period: normalizePeriod(searchParams.get("period")),
  startDate: searchParams.get("start_date") || "",
  endDate: searchParams.get("end_date") || "",
  warehouse: searchParams.get("warehouse") || "all",
});

export const buildDrilldownQuery = ({ year, month, day, period }) => ({
  year,
  month,
  period,
  day: period === SUMMARY_PERIOD.DAY ? day : undefined,
});

export const formatSelectedPeriod = ({ year, month, day, period }, t) => {
  if (period === SUMMARY_PERIOD.YEAR) return t("Period.Year", { year });
  if (period === SUMMARY_PERIOD.MONTH)
    return month ? t("Period.Month", { month: String(month).padStart(2, "0"), year }) : null;
  return month && day ? dayjs(new Date(year, month - 1, clampDayToMonth(day, year, month))).format("DD/MM/YYYY") : null;
};

export const buildDashboardBackState = ({ year, month, day, startDate, endDate, warehouse }) => ({
  dashboardFilter: {
    year,
    month,
    day,
    dateRange: startDate && endDate ? [startDate, endDate] : undefined,
    warehouse,
  },
});
